// test2740
(2740 && 0);
